{
  "name": "@ns/update-subscription-plan",
  "version": "1.1.0",
  "requiredPermission": "BILLING_MANAGE",
  "description": "Upgrade nodeStream subscription plan",
  "inputs": {
    "subscriptionId": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  }
}
